import { Application } from "@hotwired/stimulus";
import { Popover, Tabs } from "tailwindcss-stimulus-components";

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

application.register('popover', Popover);
application.register('tabs', Tabs);

export { application };
